import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarPedidosFechados(api) {        
    let parametros = {
      operacao: 'buscarPedidosFechados'
    }
    
    let retorno = {};
    await api.santriGET('/rest/orcamento', parametros, 20, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarPedidosFechados.js